'use client';

import { type FC, useRef } from 'react';

import { cn } from '@/lib/utils';

import type { TableProps } from '@/components/organisms/TableModal/TableModal.types';
import { showOverlayHook } from '@/components/organisms/TableModal/utils/showOverlayHook';
import {
    tableRowVariants,
    tbodyVariants,
} from '@/components/organisms/TableModal/utils/tableVariants';

const MobileTable: FC<TableProps> = ({
    headers,
    rows,
    className,
    ...props
}) => {
    const tbodyRef = useRef<HTMLTableSectionElement>(null);
    const isOverlayVisible = showOverlayHook(tbodyRef);

    return (
        <table
            {...props}
            className={cn('relative w-full', className)}
        >
            <tbody
                ref={tbodyRef}
                className={tbodyVariants({ overlay: isOverlayVisible })}
            >
                {rows.map((row, index) => (
                    <tr
                        key={'mobile-row-' + index}
                        className={cn(
                            tableRowVariants(),
                            'first:border-t last:mb-4',
                        )}
                    >
                        <td className="flex w-1/2 flex-col gap-y-4">
                            {headers.map((header, i) => (
                                <span
                                    key={'mobile-header-' + i}
                                    className="text-2xs text-grey-700"
                                >
                                    {header}
                                </span>
                            ))}
                        </td>

                        <td className="flex w-1/2 flex-col gap-y-4">
                            {headers.map((header, i) => (
                                <span
                                    key={'mobile-value-' + i}
                                    className="block min-h-5 text-2xs"
                                >
                                    {row[header] || ' '}
                                </span>
                            ))}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default MobileTable;
